import Router from "@/common/router/Router";

export default class DataLoggerRouter extends Router {
  static BASE_PATH = "/data_logger";
  static SHOW_ROUTE_NAME = "data-logger-show";
  static CREATE_ROUTE_NAME = "data-logger-create";
  static UPDATE_ROUTE_NAME = "data-logger-update";
  static LIST_ROUTE_NAME = "data-logger-list";

  constructor() {
    super(
      DataLoggerRouter.BASE_PATH,
      DataLoggerRouter.SHOW_ROUTE_NAME,
      DataLoggerRouter.CREATE_ROUTE_NAME,
      DataLoggerRouter.UPDATE_ROUTE_NAME,
      DataLoggerRouter.LIST_ROUTE_NAME
    );
  }
}

export const dataLoggerRouter = new DataLoggerRouter();
